<template>
  <div class="dashboard-wrapper">
    <div class="content-area">
      <div class="page-header">
        <h1 class="page-title">
          Hello!
        </h1>
      </div>

      <div class="main-content">
        <div class="data-cards-row">
          <v-card class="data-card">
            <div class="card-header">
              <span class="card-title">Live Calls</span>
              <v-btn icon size="small" variant="text" color="grey">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
            <div class="card-data">
              <span class="data-value">0</span>
            </div>
          </v-card>

          <v-card class="data-card">
            <div class="card-header">
              <span class="card-title">Tool Errors</span>
              <span class="card-subtitle">(24 Hours)</span>
            </div>
            <div class="card-data">
              <span class="data-value">0</span>
            </div>
          </v-card>

          <v-card class="data-card">
            <div class="card-header">
              <span class="card-title">Active Webhooks</span>
              <v-btn icon size="small" variant="text" color="grey">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
            <div class="card-data">
              <span class="data-value">0</span>
            </div>
          </v-card>
        </div>

        <v-card class="graph-module" outlined>
          <div class="module-header">
            <h3 class="module-title">
              Calls Made vs Calls Joined
            </h3>
          </div>

          <div class="module-content">
            <div class="left-data-cards">
              <v-card class="small-data-card">
                <div class="small-card-header">
                  <div class="color-indicator primary"/>
                  <span class="small-card-title">Calls Made</span>
                </div>
                <div class="small-card-data">
                  <span class="small-data-value">0</span>
                </div>
              </v-card>

              <v-card class="small-data-card">
                <div class="small-card-header">
                  <div class="color-indicator secondary"/>
                  <span class="small-card-title">Calls Joined</span>
                </div>
                <div class="small-card-data">
                  <span class="small-data-value">0</span>
                </div>
              </v-card>

              <v-card class="small-data-card">
                <div class="small-card-header">
                  <span class="small-card-title">Acceptance Rate</span>
                </div>
                <div class="small-card-data">
                  <span class="small-data-value">-</span>
                </div>
              </v-card>
            </div>

            <div class="empty-state">
              <div class="empty-state-icon">
                <v-icon size="48" color="grey-lighten-1">
                  mdi-phone-plus
                </v-icon>
              </div>
              <div class="empty-state-text">
                <h4>No Calls Yet</h4>
                <p>Go to playground to start a call.</p>
              </div>
              <v-btn
                color="primary"
                prepend-icon="mdi-play"
                elevation="0"
                :to="{ name: 'Playground' }">
                Go to Playground
              </v-btn>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Dashboard',
  data() {
    return {
      loading: false,
      stats: {
        liveCalls: 0,
        toolErrors: 0,
        activeWebhooks: 0,
        callsMade: 0,
        callsJoined: 0,
        acceptanceRate: '-',
      },
    };
  },
  computed: { ...mapGetters('auth', ['user']) },
  async mounted() {
    await this.loadDashboardData();
  },
  methods: {
    async loadDashboardData() {
      this.loading = true;
      try {
        // Gerçek dashboard API'larından veri çek
        await this.loadStats();
      } catch (error) {
        console.error('Dashboard data loading error:', error);
        this.$store.dispatch('ui/showNotification', {
          type: 'error',
          message: 'Dashboard verileri yüklenirken hata oluştu.',
        });
      } finally {
        this.loading = false;
      }
    },

    async loadStats() {
      try {
        // TODO: Gerçek stats API endpoint'i implement edildiğinde çağır
        // API hazır olduğunda bu veriler gerçek API'dan gelecek
      } catch (error) {
        console.error('Stats loading error:', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/variables.scss';

.main-content {
  padding: 24px;
  gap: 24px;
}

.data-cards-row {
  display: flex;
  gap: 12px;

  .data-card {
    flex: 1;
    background: #F7F8FB;
    border-radius: 12px;
    box-shadow: none;

    .card-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 12px;
      border-bottom: 1px solid #D3DAE0;
      gap: 8px;
      height: 40px;

      .card-title {
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-weight: 600;
        font-size: $body-3-size;
        line-height: 1.2em;
        color: #5C6A75;
        flex: 1;
      }

      .card-subtitle {
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-weight: 400;
        font-size: $caption-1-size;
        line-height: 1.2em;
        color: #93A0AF;
        text-align: right;
      }
    }

    .card-data {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 12px;

      .data-value {
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-weight: 700;
        font-size: $h5-size;
        line-height: 1.4em;
        color: #171D22;
      }
    }
  }
}

.graph-module {
  border: 1px solid #D3DAE0;
  border-radius: 12px;

  .module-header {
    padding: 12px 24px;
    border-bottom: 1px solid #D3DAE0;

    .module-title {
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-weight: 700;
      font-size: $body-2-size;
      line-height: 1.4em;
      color: #171D22;
      margin: 0;
    }
  }

  .module-content {
    display: flex;
    padding: 24px;
    gap: 40px;
    align-items: center;

    .left-data-cards {
      display: flex;
      flex-direction: column;
      gap: 12px;
      width: 240px;

      .small-data-card {
        background: #F7F8FB;
        border-radius: 12px;
        box-shadow: none;

        .small-card-header {
          display: flex;
          align-items: center;
          padding: 8px 12px;
          border-bottom: 1px solid #D3DAE0;
          gap: 8px;
          height: 42px;

          .color-indicator {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            position: relative;

            &.primary {
              background: #E9EDF1;

              &::after {
                content: '';
                position: absolute;
                top: 2px;
                left: 2px;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: #E9EDF1;
              }
            }

            &.secondary {
              background: #E9EDF1;

              &::after {
                content: '';
                position: absolute;
                top: 2px;
                left: 2px;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: #5C6A75;
              }
            }
          }

          .small-card-title {
            font-family: 'Plus Jakarta Sans', sans-serif;
            font-weight: 600;
            font-size: $body-3-size;
            line-height: 1.2em;
            color: #5C6A75;
          }
        }

        .small-card-data {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 12px;

          .small-data-value {
            font-family: 'Plus Jakarta Sans', sans-serif;
            font-weight: 700;
            font-size: $h5-size;
            line-height: 1.4em;
            color: #171D22;
          }
        }
      }
    }

    .empty-state {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;

      .empty-state-icon {
        width: 48px;
        height: 48px;
        background: #F7F8FB;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .empty-state-text {
        text-align: center;

        h4 {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-weight: 700;
          font-size: $body-2-size;
          line-height: 1.4em;
          color: #171D22;
          margin: 0 0 4px 0;
        }

        p {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-weight: 400;
          font-size: $caption-1-size;
          line-height: 1.6em;
          color: #5C6A75;
          margin: 0;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .data-cards-row {
    flex-direction: column;
  }

  .module-content {
    flex-direction: column;
    gap: 24px;

    .left-data-cards {
      width: 100%;
    }
  }
}
</style>
